import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyEmailAddress, 
  LocationCity,
  LocationCountry,
} from '../../utils/Constants';
import {
  COMMERCIALS_PAGE_URL,
  REVIEWS_PAGE_URL,
  WELLNESS_PAGE_URL,
} from '../../utils/Routes';
// Icons
import { FiPhone, FiMapPin } from 'react-icons/fi';
import { MdTextsms, MdEmail } from 'react-icons/md';
import {
  FaWhatsapp,
} from 'react-icons/fa';
// Data
import { socialMediaLinks } from '../../utils/data/SocialMediaData';
// Components
import SocialMediaPin from '../socialMedia/SocialMediaPin';

function ContactBlurbSection() {
  return (
    <article
      className='grid gap-8 bg-colour5 p-6 lg:p-8 rounded-2xl shadow-cardShadowBold text-colour1'
      aria-labelledby='contact-title'
      itemScope
      itemType='https://schema.org/ContactPage'
    >
      {/* Title + paragraphs */}
      <div className='grid h-fit py-4 gap-y-6'>
        <h3 id='contact-title' className='text-2xl font-titleFont font-semibold text-center'>
          Get in touch
        </h3>

        <div className='grid gap-4 text-base md:text-lg text-center leading-relaxed'>
          <p>
            I create commercials/UGC for brands and offer wellness coaching worldwide. If you’d like to discuss a project or book a session, reach out below.
          </p>
          <p>
            Use any of the contact methods or visit the pages to learn more. I’ll reply as soon as possible.
          </p>
        </div>
      </div>

      {/* Contact methods */}
      <section
        className='grid gap-y-6'
        aria-labelledby='contact-methods-title'
        itemProp='mainContentOfPage'
      >
        <h4 id='contact-methods-title' className='font-semibold text-center font-titleFont text-colour1'>
          Contact methods
        </h4>

        <ul className='grid grid-cols-1 sm:grid-cols-2 gap-4'>

          {/* Call */}
          {/* <li>
            <a
              href={`tel:${CompanyPhoneNumber}`}
              className='group grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors'
              aria-label={`Call: ${CompanyPhoneNumber}`}
              itemProp='telephone'
            >
              <FiPhone className='text-4xl text-colour1 group-hover:text-colour5 transition-colors' aria-hidden='true' />
              <div className='grid'>
                <span className='text-xl font-extrabold text-colour1 group-hover:text-colour5 transition-colors'>
                  Call
                </span>
                <span className='text-sm opacity-90 text-colour1 group-hover:text-colour5 transition-colors'>
                  {CompanyPhoneNumber}
                </span>
              </div>
            </a>
          </li> */}

          {/* Text */}
          {/* <li>
            <a
              href={`sms:${CompanyPhoneNumber}`}
              className='group grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors'
              aria-label='Send a text message'
            >
              <MdTextsms className='text-4xl text-colour1 group-hover:text-colour5 transition-colors' aria-hidden='true' />
              <div className='grid'>
                <span className='text-xl font-extrabold text-colour1 group-hover:text-colour5 transition-colors'>
                  Text
                </span>
                <span className='text-sm opacity-90 text-colour1 group-hover:text-colour5 transition-colors'>
                  {CompanyPhoneNumber}
                </span>
              </div>
            </a>
          </li>

          <li>
            <a
              href={`https://wa.me/${String(CompanyWhatsappNumber).replace(/\D/g, '')}`}
              target='_blank'
              rel='noopener noreferrer'
              className='group grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors'
              aria-label='Message on WhatsApp'
            >
              <FaWhatsapp className='text-4xl text-colour1 group-hover:text-colour5 transition-colors' aria-hidden='true' />
              <div className='grid'>
                <span className='text-xl font-extrabold text-colour1 group-hover:text-colour5 transition-colors'>
                  WhatsApp
                </span>
                <span className='text-sm opacity-90 text-colour1 group-hover:text-colour5 transition-colors'>
                  {CompanyWhatsappNumber}
                </span>
              </div>
            </a>
          </li> */}

          {/* Email */}
          <li className='col-span-2'>
            <a
              href={`mailto:${CompanyEmailAddress}`}
              className='group grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors'
              aria-label={`Email: ${CompanyEmailAddress}`}
              itemProp='email'
            >
              <MdEmail className='text-4xl text-colour1 group-hover:text-colour5 transition-colors' aria-hidden='true' />
              <div className='grid'>
                <span className='text-xl font-extrabold text-colour1 group-hover:text-colour5 transition-colors'>
                  Email
                </span>
                <span className='text-sm break-all opacity-90 truncate text-colour1 group-hover:text-colour5 transition-colors'>
                  {CompanyEmailAddress}
                </span>
              </div>
            </a>
          </li>

          {/* Address (not a link, but matches hover treatment for consistency) */}
          <li className='sm:col-span-2'>
            <div className='group grid grid-cols-[auto_1fr] items-start gap-4 px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 hover:bg-colour3 transition-colors'>
              <FiMapPin className='text-4xl mt-1 text-colour1 group-hover:text-colour5 transition-colors' aria-hidden='true' />
              <div className='grid'>
                <span className='text-xl font-extrabold text-colour1 group-hover:text-colour5 transition-colors'>
                  Location
                </span>
                <address className='not-italic text-sm opacity-90 text-colour1 group-hover:text-colour5 transition-colors'>
                  {LocationCity}, {LocationCountry}
                </address>
              </div>
            </div>
          </li>

          {/* Internal links */}
          <li>
            <Link
              to={COMMERCIALS_PAGE_URL}
              className='group grid place-items-center px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors text-lg font-semibold'
              aria-label='View Commercials & UGC'
            >
              <span className='group-hover:text-colour5 transition-colors'>Commercials &amp; UGC</span>
            </Link>
          </li>

          <li>
            <Link
              to={WELLNESS_PAGE_URL}
              className='group grid place-items-center px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors text-lg font-semibold'
              aria-label='View Wellness Coaching'
            >
              <span className='group-hover:text-colour5 transition-colors'>Wellness Coaching</span>
            </Link>
          </li>

          <li className='sm:col-span-2'>
            <Link
              to={REVIEWS_PAGE_URL}
              className='group grid place-items-center px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5 text-colour1 hover:bg-colour3 transition-colors text-lg font-semibold'
              aria-label='Read reviews'
            >
              <span className='group-hover:text-colour5 transition-colors'>Read Reviews</span>
            </Link>
          </li>

          {/* Socials (Follow) — left ALONE as requested */}
          {socialMediaLinks.length > 0 && (
            <li className='sm:col-span-2'>
              <div className='grid items-center gap-2 px-5 py-4 rounded-2xl shadow-cardShadowBold bg-colour5'>
                <span className='text-colour1 text-center text-lg font-semibold'>
                  Follow
                </span>
                <nav
                  aria-label='Social media'
                  className='grid grid-flow-col justify-center auto-cols-max gap-4 items-center text-colour1'
                >
                  {socialMediaLinks.map((social) => (
                    <SocialMediaPin
                      key={social.serviceName}
                      serviceName={social.serviceName}
                      icon={social.icon}
                      url={social.url}
                      ariaLabel={social.ariaLabel}
                      title={social.title}
                    />
                  ))}
                </nav>
              </div>
            </li>
          )}
        </ul>
      </section>
    </article>
  );
}

export default ContactBlurbSection;
